module.exports = __webpack_public_path__ + "assets/dadfe508edc62dd7b09d0d91599abc17.jpg";